/**
 * Theme: Amezia - Responsive Bootstrap 4 Admin Dashboard
 * Author: Themesbrand
 * Form Advanced
 */



$(function () {
  // Select2
  $(".select2").select2({
    width: '100%'
  });

  // Date Picker
  jQuery('.datepicker').datepicker();
    jQuery.extend(jQuery.fn.datepicker.defaults, {
      format: 'dd/mm/yyyy',
      weekStart: 1,
      language: !localStorage.getItem('locale') ? 'it' : localStorage.getItem('locale'),
      clearBtn: true,
    });
    jQuery('.datepicker-autoclose, .datepicker-autoclose2, .datepicker-autoclose3').datepicker({
        autoclose: true,
        orientation: 'bottom'
    });
    jQuery('.datepicker-inline').datepicker();
    jQuery('.datepicker-multiple-date').datepicker({
      clearBtn: true,
      multidate: true,
      multidateSeparator: ","
    });
    jQuery('.date-range').datepicker({
      toggleActive: true
    });
});
